import {
  CommentRequest,
  CommentResponse,
  GetCommentsRequest,
  GetCommentsResponse,
  GetLikesRequest,
  GetLikesResponse,
  GetRepliesRequest,
  GetRepliesResponse,
  LikeResponse,
  ReplyRequest,
  ReplyResponse,
} from '../interfaces'
import { POST, POSTWithAuth, POSTWithAuthNoResponse } from './Index'

export async function CreateComment(
  creator: string,
  activity_id: string,
  content: string
): Promise<CommentResponse> {
  return await POSTWithAuth<CommentRequest, CommentResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/users/${creator}/videos/${activity_id}/comment`,
    {
      content,
    }
  )
}

export async function CreateReply(
  creator: string,
  activity_id: string,
  comment_id: string,
  content: string
): Promise<ReplyResponse | undefined> {
  return await POSTWithAuth<ReplyRequest, ReplyResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/users/${creator}/videos/${activity_id}/comments/${comment_id}/reply`,
    {
      content,
    }
  )
}

export async function LikeComment(
  creator: string,
  activity_id: string,
  comment_id: string
): Promise<LikeResponse> {
  return await POSTWithAuth<null, LikeResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/users/${creator}/videos/${activity_id}/comments/${comment_id}/like`,
    null
  )
}

export async function UnlikeComment(
  creator: string,
  activity_id: string,
  comment_id: string,
  like_id: string
): Promise<void> {
  return await POSTWithAuthNoResponse<null>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/users/${creator}/videos/${activity_id}/comments/${comment_id}/likes/${like_id}/delete`,
    null
  )
}

export async function LikeReply(
  creator: string,
  activity_id: string,
  comment_id: string,
  reply_id: string
): Promise<LikeResponse> {
  return await POSTWithAuth<null, LikeResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/users/${creator}/videos/${activity_id}/comments/${comment_id}/replies/${reply_id}/like`,
    null
  )
}

export async function UnlikeReply(
  creator: string,
  activity_id: string,
  comment_id: string,
  reply_id: string,
  like_id: string
): Promise<void> {
  return await POSTWithAuthNoResponse<null>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/users/${creator}/videos/${activity_id}/comments/${comment_id}/replies/${reply_id}/likes/${like_id}/delete`,
    null
  )
}

export async function LikeVideo(creator: string, activity_id: string): Promise<LikeResponse> {
  return await POSTWithAuth<null, LikeResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/users/${creator}/videos/${activity_id}/like`,
    null
  )
}

export async function UnlikeVideo(
  creator: string,
  activity_id: string,
  like_id: string
): Promise<void> {
  return await POSTWithAuthNoResponse<null>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/users/${creator}/videos/${activity_id}/likes/${like_id}/delete`,
    null
  )
}

export async function DeleteComment(
  creator: string,
  activity_id: string,
  comment_id: string
): Promise<void> {
  return await POSTWithAuthNoResponse(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/users/${creator}/videos/${activity_id}/comments/${comment_id}/delete`,
    null
  )
}

export async function DeleteReply(
  creator: string,
  activity_id: string,
  comment_id: string,
  reply_id: string
): Promise<void> {
  return await POSTWithAuthNoResponse(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/users/${creator}/videos/${activity_id}/comments/${comment_id}/replies/${reply_id}/delete`,
    null
  )
}

export async function GetVideoLikes(
  user_id: string,
  activity_id: string
): Promise<GetLikesResponse> {
  return await POST<GetLikesRequest, GetLikesResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/get-video-likes`,
    {
      user_id,
      activity_id,
    }
  )
}

export async function GetVideoComments(
  user_id: string,
  activity_id: string,
  last_reaction_id: string
): Promise<GetCommentsResponse> {
  return await POST<GetCommentsRequest, GetCommentsResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/get-video-comments`,
    {
      user_id,
      activity_id,
      last_reaction_id,
    }
  )
}

export async function GetCommentReplies(
  user_id: string,
  comment_id: string,
  last_reaction_id: string
): Promise<GetRepliesResponse> {
  return await POST<GetRepliesRequest, GetRepliesResponse>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/get-comment-replies`,
    {
      user_id,
      comment_id,
      last_reaction_id,
    }
  )
}
